import { keyBy, merge, cloneDeep, partition } from "lodash";
import { feedPlanNullEmptyCheck, valueIsNumberValue } from "./feedCurveTableUtils";
import { FeedCurve, FeedPlanEntry } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";
import { FeedCurveSpreadingRow } from "./feedCurveSpreadingUtil";
import { SelectFieldOption_Values } from "../../../Definitions";
import { MaintainFeedCurve } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/maintainFeedCurveCall";
import { Dispatch, MutableRefObject, SetStateAction } from "react";


export function updateSpreadingTable(rowId: number, columnId: string, value: string | number | boolean | SelectFieldOption_Values | undefined, data: Map<number, FeedCurveSpreadingRow>, feedCurve: FeedCurve, feedPlans: FeedPlanEntry[][], dirtRef: MutableRefObject<MaintainFeedCurve>, setFeedPlans: Dispatch<SetStateAction<FeedPlanEntry[][]>>, shouldContinuesDays: boolean) {
  const oldRow = data.get(rowId);
  const day = oldRow?.day;
  if (feedCurve.milestones) {
    if (columnId === "milestoneSpreading") {
      return
    }
    if (columnId === "day" && valueIsNumberValue(value, columnId) && oldRow && day !== undefined) {
      const feedPlanEntries = feedPlans[oldRow.milestoneArrayIndex].filter((feedPlanEntry) => (feedPlanEntry.day === day));
      feedPlanEntries.forEach((feedPlanEntry) => {
        feedPlanEntry.day = shouldContinuesDays ? value - oldRow.milestoneFirstDay : +value;
      })

      const [newValue, updateValue] = partition(feedPlanEntries, (entry) => (oldRow.newDay || entry.feedPlanEntryId < 1));

      if (newValue.length > 0) {
        if (dirtRef.current.creates === undefined) {
          dirtRef.current.creates = {};
        }

        const newFeedPlanEntries = newValue.map(({ amount, day, timeId }) => ({ amount: +amount, day, time_id: timeId, temporaryId: `${day}-${timeId}` })).filter((entry) => entry.time_id !== 0);

        // Since a valid feedCurveMilestoneId is supplied the 
        const newMilestoneEntry = { feedCurveMilestoneId: oldRow.feedCurveMilestoneId, temporaryId: oldRow.feedCurveMilestoneId, milestone_index: oldRow.milestoneIndex, milestone_id: oldRow.milestoneId, feedPlan: newFeedPlanEntries }
        if (dirtRef.current.creates.milestones) {
          const dirtyMilestone = dirtRef.current.creates.milestones.find((milestone) => (milestone.temporaryId === oldRow.feedCurveMilestoneId));
          if (dirtyMilestone) {
            const oldTemporaryIds = newValue.map((entry) => (`${day}-${entry.timeId}`));
            dirtyMilestone.feedPlan = Object.values(merge({}, keyBy(dirtyMilestone.feedPlan, "temporaryId"), keyBy(newFeedPlanEntries, "temporaryId"))).filter((dirtyEntry) => (!oldTemporaryIds.includes(dirtyEntry.temporaryId)));
          } else {
            dirtRef.current.creates.milestones = [...dirtRef.current.creates.milestones, newMilestoneEntry]
          }
        } else {
          dirtRef.current.creates.milestones = [newMilestoneEntry];
        }
      }

      if (updateValue.length > 0) {
        if (dirtRef.current.updates === undefined) {
          dirtRef.current.updates = {};
        }
        dirtRef.current.updates.feedPlan = Object.values(merge({}, keyBy(dirtRef.current.updates.feedPlan, "feedPlanEntryId"), keyBy(updateValue.map((entry) => ({ feedPlanEntryId: entry.feedPlanEntryId, baseInfo: { day: entry.day } })), "feedPlanEntryId")))
      }

      setFeedPlans(cloneDeep(feedPlans));
      return

    }
    if (oldRow && day !== undefined && feedPlanNullEmptyCheck(value, columnId)) {
      const feedPlanEntry = feedPlans[oldRow.milestoneArrayIndex].find((feedPlan) => (feedPlan.day === day && feedPlan.timeId === +columnId));
      if (+columnId < 0 || oldRow.newDay || feedPlanEntry === undefined || feedPlanEntry.feedPlanEntryId < 1) {
        // We are in a new column or a new row day !== undefinedor the value for the day haven't existed or we need to update a create value
        if (dirtRef.current.creates === undefined) {
          dirtRef.current.creates = {};
        }
        feedPlanEntry ? feedPlanEntry.amount = +value : feedPlans[oldRow.milestoneArrayIndex].push({ day: day, amount: +value, feedPlanEntryId: 0, timeId: +columnId })

        const newFeedPlanEntry = { amount: +value, day: day, time_id: +columnId, temporaryId: `${day}-${columnId}` }
        const newMilestoneEntry = { feedCurveMilestoneId: oldRow.feedCurveMilestoneId, temporaryId: oldRow.feedCurveMilestoneId, milestone_index: oldRow.milestoneIndex, milestone_id: oldRow.milestoneId, feedPlan: [newFeedPlanEntry] }

        if (dirtRef.current.creates.milestones) {
          const dirtyMilestone = dirtRef.current.creates.milestones.find((milestone) => (milestone.temporaryId === oldRow.feedCurveMilestoneId));
          if (dirtyMilestone) {
            dirtyMilestone.feedPlan = Object.values(merge({}, keyBy(dirtyMilestone.feedPlan, "temporaryId"), keyBy([newFeedPlanEntry], "temporaryId")))
            setFeedPlans(cloneDeep(feedPlans));
            return
          }
        }

        dirtRef.current.creates.milestones = Object.values(merge({}, keyBy(dirtRef.current.creates.milestones, "temporaryId"), keyBy([newMilestoneEntry], "temporaryId")));
        setFeedPlans(cloneDeep(feedPlans));
        return
      }

      if (dirtRef.current.updates === undefined) {
        dirtRef.current.updates = {};
      }
      if (dirtRef.current.updates.feedPlan === undefined) {
        dirtRef.current.updates.feedPlan = [];
      }
      feedPlanEntry.amount = +value;
      dirtRef.current.updates.feedPlan = Object.values(merge({}, keyBy(dirtRef.current.updates.feedPlan, "feedPlanEntryId"), keyBy([{ feedPlanEntryId: feedPlanEntry.feedPlanEntryId, baseInfo: { amount: +value } }], "feedPlanEntryId")))
      setFeedPlans(cloneDeep(feedPlans))
      return
    }
    if (oldRow && day !== undefined) {
      const feedPlanEntryIndex = feedPlans[oldRow.milestoneArrayIndex].findIndex((feedPlan) => (feedPlan.day === day && feedPlan.timeId === +columnId))
      if (feedPlanEntryIndex === -1) {
        return;
      }
      const feedPlanEntry = feedPlans[oldRow.milestoneArrayIndex][feedPlanEntryIndex]

      if (+columnId < 0 || oldRow.newDay || feedPlanEntry.feedPlanEntryId < 1) {
        const dirtyMilestoneIndex = dirtRef.current.creates?.milestones?.findIndex((milestone) => (milestone.temporaryId === oldRow.feedCurveMilestoneId));
        if (dirtRef.current.creates?.milestones && (dirtyMilestoneIndex !== -1 && dirtyMilestoneIndex !== undefined)) {
          dirtRef.current.creates.milestones[dirtyMilestoneIndex].feedPlan = dirtRef.current.creates.milestones[dirtyMilestoneIndex].feedPlan?.filter((feedPlan) => !(feedPlan.temporaryId === `${day}-${columnId}`))
        }
        feedPlans[oldRow.milestoneArrayIndex].splice(feedPlanEntryIndex, 1)
        setFeedPlans(cloneDeep(feedPlans));
        return
      }
      if (dirtRef.current.deletes === undefined) {
        dirtRef.current.deletes = {};
      }
      if (dirtRef.current.deletes.feedPlan === undefined) {
        dirtRef.current.deletes.feedPlan = [];
      }
      dirtRef.current.deletes.feedPlan.push(feedPlanEntry.feedPlanEntryId);
      feedPlans[oldRow.milestoneArrayIndex].splice(feedPlanEntryIndex, 1)
      setFeedPlans(cloneDeep(feedPlans));
      return
    }
  }
}
